<ion-header *ngIf="!showIOSATTScreen && !showEmbedElt && !displayModalPostRegistration && !displayModalCPFSubscription && !displayModalDailyStreak">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>
  <div *ngIf="!showIOSATTScreen">
    <!-- <page-loader-comp *ngIf="!longLoading && ((userLifeCycle?.isUserEngaged && !examenCodeDone) || (!userLifeCycle?.isUserEngaged && !cardsListDone))"></page-loader-comp> -->
    
    <!-- <div class="margin-20">
      <custom-radio-comp [compOptions]="{'options': customRadioOptions}" (userSelection)="getCustomRadioSelection($event)"></custom-radio-comp>
    </div>
    <div class="margin-20">
      <custom-radio-comp [compOptions]="{'options': customRadioOptions, selected: 'total', isWhite: true, isSmall: true}" (userSelection)="getCustomRadioSelection($event)"></custom-radio-comp>
    </div> -->

    <!-- <div *ngIf="!isCordova" class="gradient-scroll"></div> -->

    <!-- PROMO DECONF -->
    <!-- <div *ngIf="!isEngaged && cardsListDone" class="pub-summer2020 margin-bottom-0" (click)="openLink('promosummer2020')"><span>Soldes d'été : réduction de 50€ sur le Pack Permis avec le code SUMMER2020. <u>Plus d'infos ici</u></span></div> -->
    
    <div [ngClass]="{'max-width-600': ((examReservationWaitingCredits && isDesktop) || !examReservationWaitingCredits) || ((CPFStartingSoon && isDesktop) || !CPFStartingSoon) || ((CPFInEDOFErrorStatus && isDesktop) || !CPFInEDOFErrorStatus)}">

      <!-- CPF STARTING SOON -->
      <div *ngIf="CPFStartingSoon.length > 0" class="cpf-starting-soon">
        <div class="cpf-wrapper" *ngFor="let CPF of CPFStartingSoon">
          <div class="icon"><img src="assets/2022/icons/info-square-off-white.svg" width="24"></div>
          <div>Ta souscription CPF N°{{CPF.external_id}} prendra effet le <b>{{CPF.session_start_date}}</b>. Tes crédits seront disponibles à cette date sur ton compte En Voiture Simone</div>
        </div>
      </div>

      <!-- CPF IN EDOF ERROR STATUS -->
      <div *ngIf="CPFInEDOFErrorStatus.length > 0" class="cpf-in-edof-error-status">
        <div class="cpf-wrapper" *ngFor="let CPF of CPFInEDOFErrorStatus">
          <div class="icon"><img src="assets/2022/icons/info-square-off-white.svg" width="24"></div>
          <div>Ton dossier est en cours de traitement par le site du CPF. Une fois validé, tes crédits CPF seront ajoutés à ton compte En Voiture Simone</div>
        </div>
      </div>

      <!-- AWAITING CREDITS -->
      <div *ngIf="examReservationWaitingCredits" class="no-credit-for-exam clickable" [ngClass]="{'double-bandeau': CPFStartingSoon || CPFInEDOFErrorStatus}" (click)="crediterCompte(missingCredits)">
        <div class="icon"><img src="assets/2022/icons/info-circle-off-white.svg" width="24"></div>
        <div><b>IMPORTANT :</b> crédit(s) manquant(s) pour ta réservation d'examen</div>
      </div>
  
      <!-- GAMIFICATION -->
      <div id="gamification-global-header" [ngClass]="{'double-bandeau': examReservationWaitingCredits || CPFStartingSoon || CPFInEDOFErrorStatus}" (click)="openLink('reussites')">
        <div [ngClass]="{'clickable gamification-global-wrapper': true}">
          <span class="text bold">
            Ma route vers le Permis
          </span>
          <div *ngIf="!gamificationService.fetchBadgesFailed" class="loader-bar">
            <loader-bar-comp [compOptions]="{ percent: gamificationService.obtainedBadgesInPercentage, hasBorder: true, rounded: true }"></loader-bar-comp>
          </div>
          <div *ngIf="gamificationService.fetchBadgesFailed" class="warning-bar"></div>
          <span *ngIf="!gamificationService.fetchBadgesFailed && !!gamificationService.studentRank" class="sub-text">
            {{ gamificationService.studentRank }}
          </span>
          <span *ngIf="!gamificationService.fetchBadgesFailed && !gamificationService.studentRank" class="sub-text">
            Chargement...
          </span>
          <span *ngIf="gamificationService.fetchBadgesFailed" class="sub-text">Une erreur est survenue</span>
        </div>
        <div *ngIf="!gamificationService.fetchBadgesFailed" class="circle-arrow">
          <img *ngIf="!!gamificationService.studentRank" src="assets/2022/icons/arrow-right-on.svg" width="20">
          <img class="infinite-rotating" *ngIf="!gamificationService.studentRank" src="assets/2022/icons/reload.svg">
        </div>
        <img *ngIf="gamificationService.fetchBadgesFailed" class="position-absolute right-15 warning-pulse" src="assets/svg/warning-ico.svg" width="24">
      </div>
    </div>

    <div class="ion-content-container" [ngClass]="{'margin-bottom-16': !isDesktop}">

      <button *ngIf="addEntriesForDebug" class="btn full-width margin-bottom-20" (click)="duplicateSeries()">Duplicate</button>
      <!-- DEBUG FOR TEST -->
      <!-- <button class="btn full-width max-width-600 display-block margin-bottom-20" (click)="openModalPack(null, 'modalConsentPush')">Push Notif</button> -->
      <!-- DEBUG FOR TEST -->
      
      <div class="max-width-600" [ngClass]="{'margin-bottom-20': !isDesktop}" *ngIf="cardsListDone && hasPromoCard">
        <card-comp *ngIf="promoCardTemplate === 'happygift'" class="wpe-100" [compOptions]="{'canClick': true, id: {link: 'permis', card: ''}, nested: true, type: 'big-conduite promo-happygift clickable-safari', safariFix: true}" (click)="triggerCardActionById({link: 'permis', card: ''})">
          <div class="big-card-conduite-bg"></div>
          <div class="big-card-conduite">
            <h3>
              Pack Permis<br>
              <del>{{packPermisPrice}}</del> 699€
            </h3>
            <p>
              Livret de code<br>
              Assistance<br>
              {{packPermisHours}} de conduite
            </p>
          </div>
        </card-comp>
        
        <card-comp *ngIf="promoCardTemplate === 'default'" class="wpe-100" [ngClass]="{'pub-in-app': !isDesktop}" [compOptions]="{'canClick': true, id: {link: 'permis', card: {}}, nested: true, type: 'big-card evs-card-grey-pattern-1'}" (click)="triggerCardActionById({link: 'permis', card: {}})">
          <div [innerHTML]="'Qui dit Noël, dit cadeau 🎁&nbsp;!<br>50 € de réduction sur le Pack Permis avec le code NOELDESIMONE.'"></div>
          <button *ngIf="isDesktop" class="btn small light white">
            <span class="margin-rigth-8">Profiter de l'offre<img src="assets/2022/icons/arrow-main-text.svg" alt="EnVoitureSimone"></span>
          </button>
        </card-comp>
      </div>

      <div class="max-width-600" [ngClass]="{'margin-bottom-20': !isDesktop}" *ngIf="userLifeCycle.isUserGuest && cardsListDone && !hasPromoCard">
        <card-comp class="wpe-100" [ngClass]="{'pub-in-app': !isDesktop, 'big-card-center': !pubInAppGuestCard.cta}" [compOptions]="{'canClick': true, id: {link: pubInAppGuestCard.link, card: pubInAppGuestCard.card}, nested: true, type: 'big-card evs-card-grey-pattern-1'}" (click)="triggerCardActionById({link: pubInAppGuestCard.link, card: pubInAppGuestCard.card})">
          <div *ngIf="!!pubInAppGuestCard.text" [innerHTML]="pubInAppGuestCard.text"></div>
          <button *ngIf="!!pubInAppGuestCard.cta" class="btn small light white">
            <span class="margin-rigth-8">{{card.cta}}<img src="assets/2022/icons/arrow-main-text.svg" alt="EnVoitureSimone"></span>
          </button>
        </card-comp>
      </div>
      
      <div class="max-width-600" [ngClass]="{'margin-bottom-20': !isDesktop}" *ngIf="cardsListDone && (!hasHours && !isPackPermis && !userLifeCycle.isUserGuest) && !hasPromoCard">
        <card-comp class="wpe-100" [ngClass]="{'pub-in-app': !isDesktop, 'big-card-center': !pubInAppRegisteredCard.cta}" [compOptions]="{'canClick': true, id: {link: pubInAppRegisteredCard.link, card: pubInAppRegisteredCard.card}, nested: true, type: 'big-card evs-card-grey-pattern-1'}" (click)="triggerCardActionById({link: pubInAppRegisteredCard.link, card: pubInAppRegisteredCard.card})">
          <div *ngIf="!!pubInAppRegisteredCard.text" [innerHTML]="pubInAppRegisteredCard.text"></div>
          <button *ngIf="!!pubInAppRegisteredCard.cta" class="btn small light white">
            <span class="margin-rigth-8">{{card.cta}}<img src="assets/2022/icons/arrow-main-text.svg" alt="EnVoitureSimone"></span>
          </button>
        </card-comp>
      </div>

      <div class="max-width-600 call-center-container" [ngClass]="{'margin-bottom-20': !isDesktop}" >
        <a class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
          <div class="call-center-wrapper evs-card">
            <div class="call-center-text-wrapper">
              <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
              <div class="call-center-desc">Appelle le <span class="highlight">{{ callCenterPhone }}</span> (appel gratuit)</div>
            </div>
            <img class="call-center-img" src="assets/svg/picto_call.svg" alt="En Voiture Simone">
          </div>
        </a>
      </div>

      <ng-container *ngFor="let group of groupList; let ix = index">
        <div class="max-width-600 bold margin-bottom-16">
          <div *ngIf="(((userLifeCycle?.isUserEngaged && !examenCodeDone) || (!userLifeCycle?.isUserEngaged && !cardsListDone)) && ix > 0)" class="separator"></div>
          <div *ngIf="((userLifeCycle?.isUserEngaged || userLifeCycle?.isUserCanDrive || userLifeCycle?.isUserDrivingSuccess) && examenCodeDone && ix > 0) || ((!userLifeCycle?.isUserEngaged && !userLifeCycle?.isUserCanDrive && !userLifeCycle?.isUserDrivingSuccess) && cardsListDone) || (cardsListDone && hasPromoCard) || (cardsListDone && !hasHours && !isPackPermis)" [ngClass]="{'': (!isCordova && isDesktop)}" class="separator"></div>
          
          <!-- <div *ngIf="longLoading && ((userLifeCycle?.isUserEngaged && !examenCodeDone) || (!userLifeCycle?.isUserEngaged && !cardsListDone))" class="wpi-150 border-radius-6 padding-8 dark-shimmer"></div> -->
          <h5 class="margin-bttom-16" [ngClass]="{'': (!isCordova && isDesktop), 'group-title-with-daily-streak': group === 'Entraînements au code' && isMaxMobile && !userLifeCycle.isUserGuest }">
            {{group}}
            <span class="small-clickable daily-streak-degraded" *ngIf="group === 'Entraînements au code' && isMaxMobile && !userLifeCycle.isUserGuest && !dailyStreakLoading && !!dailyStreakDays && dailyStreakDays.length > 0" (click)="triggerCardActionById('daily-streak')">{{dailyStreakDegradedText}}<img class="flame-streak" src="assets/2022/icons/flamme.svg"></span>
          </h5>
        </div>
        <!-- <div class="max-width-600" *ngIf="longLoading && ((userLifeCycle?.isUserEngaged && !examenCodeDone) || (!userLifeCycle?.isUserEngaged && !cardsListDone))">
          <div class="evs-card evs-card-code-home-card-shimmer evs-card-code-home-card margin-bottom-8" [ngClass]="{'': (!isCordova && isDesktop)}" *ngFor="let card of utils.numberToArray(3)">
            <div class="icon-container bg-white">
              <div [ngClass]="{'circle-40': isDesktop, 'circle-30': !isDesktop}" class="shimmer"></div>
            </div>
            <div class="wpe-60 border-radius-6 padding-6 shimmer"></div>
          </div>
        </div> -->
        <div class="max-width-600 cards-container">
          <ng-container *ngFor="let card of cardsList; let i = index">
            <card-comp class="card-comp-neph-infos" *ngIf="!!initFullDone && group === card.group && card.link === 'neph-infos' && !!displayNEPHInfosCard" [compOptions]="{id: card.link, type: (!isCordova && isDesktop) ? 'code-home-card-neph-infos' : 'code-home-card-neph-infos'}" (click)="triggerCardActionById(card.link)">
              <div class="text-container">
                <p class="bold">Renseigne ton NEPH ou inscris-toi rapidement sur l'ANTS !</p>
                <p>C'est obligatoire ! Sans ça, tu ne peux pas passer ton code, ni réserver tes heures de conduite.</p>
              </div>
              <img class="arrow" src="assets/2022/icons/arrow-right-2-off-white.svg" width="24">
            </card-comp>
            <card-comp *ngIf="group === card.group && card.link === 'daily-streak' && !isMaxMobile && !userLifeCycle.isUserGuest && !!dailyStreakDays && dailyStreakDays.length > 0" [compOptions]="{id: card.link, type: (!isCordova && isDesktop) ? 'code-home-card-dailystreak' : 'code-home-card-dailystreak'}" (click)="triggerCardActionById(card.link)">
              <div class="text-container" [ngClass]="{'two-lines': !!card.subtitle && card.subtitle !== ''}">
                {{card.title}}
              </div>
              <div class="dailystreak-container">
                <div class="days-container">
                  <div class="day-container" *ngFor="let day of dailyStreakDays">
                    <img *ngIf="day.isStreak" class="streak-indicator-active" src="assets/2022/icons/tick-white.svg">
                    <div *ngIf="!day.isStreak" class="streak-indicator-inactive"></div>
                    <p [ngClass]="{'text-streak-active': day.isActive}">{{ day.dayString }}</p>
                    <div *ngIf="day.isActive" class="active-indicator"></div>
                  </div>
                </div>
                <div class="streak-container">
                  <p>{{ gamificationService.dailyStreaks.daily_streak_current }}</p>
                  <img class="flame-streak" src="assets/2022/icons/flamme_border.svg">
                </div>
              </div>
            </card-comp>
            <card-comp *ngIf="group === card.group && card.link !== 'daily-streak' && card.link !== 'neph-infos'" [compOptions]="{id: card.link, type: (!isCordova && isDesktop) ? 'code-home-card ' : 'code-home-card'}" (click)="triggerCardActionById(card.link)">
              <div class="icon-container">
                <img [alt]="'Icone ' + card.title" [src]="'assets/2022/pictos/' + card.icon + '.svg'">
              </div>
              <div class="text-container" [ngClass]="{'two-lines': !!card.subtitle && card.subtitle !== ''}">
                {{card.title}}
                <div class="sub-title" *ngIf="!!card.subtitle && card.subtitle !== ''">{{card.subtitle}}</div>
                <div *ngIf="card.title == 'Mes erreurs' && initServiceDone && nbErrorsDone && nbErreurs > 0 && !seriesListFailed" class="badge-erreurs" [ngClass]="{'small-counter': nbErreurs > 99}">{{nbErreurs}}</div>
              </div>
              <img *ngIf="card.title !== 'Mes erreurs' || (card.title == 'Mes erreurs' && nbErreurs === 0 && initServiceDone && cardsListDone)" class="arrow" src="assets/2022/icons/arrow-right-2-off.svg" width="24">
              <img *ngIf="card.title == 'Mes erreurs' && initServiceDone && nbErrorsDone && (seriesListFailed || getSerieFailed)" src="assets/svg/warning-ico.svg" width="24" class="arrow">
              <ion-spinner name="dots" class="arrow" *ngIf="card.title == 'Mes erreurs' && (!initServiceDone || !nbErrorsDone) && !seriesListFailed"></ion-spinner>
            </card-comp>
          </ng-container>
        </div>
      </ng-container>

      <!-- <button class="btn" (click)="openModalPack('marketingRegular')">marketingRegular</button>
      <button class="btn" (click)="openModalPack('marketingZendesk')">marketingZendesk</button>
      <button class="btn" (click)="openModalPack('marketingExamCode')">marketingExamCode</button>
      <button class="btn" (click)="openModalPack('marketingExamConduite')">marketingExamConduite</button> -->

    </div>

    <!-- FAQ -->
    <div *ngIf="(userLifeCycle?.isUserEngaged && examenCodeDone) || (!userLifeCycle?.isUserEngaged && cardsListDone)" class="margin-bottom-16 gamification-faq small-clickable" (click)="openLink('faq')">
      <div class="faq-icon"></div>
      <p>
        Un doute&nbsp;? Une question&nbsp;?
      </p>
    </div>

    <!-- MODAL MAJ CODE 2023 -->
    <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayMajCode2023">
      <div class="text-box">
        <h4 class="title">Nouvelles questions disponibles !</h4>
        <p class="text">Clique sur “Mettre à jour” et découvre nos nouvelles séries et questions, toujours 100% conformes à l’examen 👌</p>
      </div>
      <div class="button">
        <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
          <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
        </button>
      </div>
    </modal-comp>
  
    <!-- MODAL RESTART CODE 2023 -->
    <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayRestartCode2023">
      <div class="text-box">
        <h4 class="title">Nouvelles questions disponibles !</h4>
        <p class="text">Redémarre ton application pour afficher les nouvelles questions de code.<br>Tes sessions seront remises à jour.</p>
      </div>
      <div class="button">
        <button class="btn full-width" (click)="restartCode2023()">Redémarrer l'app</button>
      </div>
    </modal-comp>
  
    <!-- MODAL ERROR CODE 2023 -->
    <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayErrorCode2023">
      <div class="text-box">
        <h4 class="title">Une erreur est survenue</h4>
        <p class="text">Essaye à nouveau de mettre à jour l’application<br>{{majCallError}}</p>
      </div>
      <div class="button">
        <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
          <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
        </button>
      </div>
    </modal-comp>
  
    <!-- MODAL DRIVING TRAINING MAJ CODE 2023 -->
    <!-- <modal-comp [compOptions]="{'id': 'customModalMajCode2023', closable: false}"  *ngIf="displayDrivingTrainingMajCode2023">
      <div class="text-box">
        <h4 class="title">Nouvelles questions disponibles !</h4>
        <p class="text">Clique sur “Mettre à jour” et découvre nos nouvelles séries et questions, toujours 100% conformes à l’examen 👌</p>
      </div>
      <div class="button">
        <button class="btn light full-width margin-bottom-8" (click)="majCode2023(true)">Annuler</button>
        <button class="btn full-width" (click)="majCode2023(false)">Mettre à jour
          <ion-spinner *ngIf="showSpiner" class="custom-spinner" name="crescent"></ion-spinner>
        </button>
      </div>
    </modal-comp> -->

    <modal-comp [compOptions]="{'id': 'customModalDossierExam1'}" *ngIf="displayModalDossierExam1" (canClose)="hideModalDossierExam1()">
      <h4>Plus qu’une étape&nbsp;!</h4>
      <p>Pour réserver ton examen, tu dois mettre en ligne ton attestation d’inscription. Une fois validée par notre équipe, tu peux choisir ta date d’examen dans le centre La Poste de ton choix.</p>
      <button class="btn center" (click)="openLink('dossier')">Mettre en ligne mon attestation</button>
    </modal-comp>
    
    <modal-comp [compOptions]="{'id': 'customModalDossierExam2', dynamicHeight: true, closable: false}" *ngIf="displayModalDossierExam2" (canClose)="hideModalDossierExam2()">
      <h4>Ton document est en cours de validation</h4>
      <p>Ton attestation d’inscription est en cours de vérification par notre équipe. Une fois validée, tu recevras un mail de confirmation et pourras choisir ta date d’examen dans le centre La Poste de ton choix.</p>
      <button class="btn center" (click)="hideModalDossierExam2()">J’ai compris</button>
    </modal-comp>
    
    <modal-comp class="text-center" [compOptions]="{'id': 'customModalNoErrors', closable: false}" *ngIf="displayModalNoErrors" (canClose)="hideModalNoErrors()" #modalNoErrors>
      <h4>Mes erreurs</h4>
      <p>Tu n'as pas fait d'erreur... Bravo&nbsp;!<br>Essaye d'autres modes d'entraînement et reviens plus tard.</p>
      <button class="btn center" (click)="callHideModalNoErrors()">J’ai compris</button>
    </modal-comp>

    <modal-comp class="text-center" [compOptions]="{'id': 'customModalSeriesFailed', closable: false}" *ngIf="displayModalSeriesFailed" (canClose)="hideModalSeriesFailed()" #modalSeriesFailed>
      <h4>Mes erreurs</h4>
      <p>Ce mode est indisponible pour le moment&nbsp;!<br>Essaye de revenir plus tard.</p>
      <button class="btn center" (click)="callHideModalSeriesFailed()">J’ai compris</button>
    </modal-comp>
  </div>

  <ios-att-slider-comp *ngIf="showIOSATTScreen" (outputIOSATT)="closeIOSATTScreen($event)"></ios-att-slider-comp>

  <!-- TUNNEL POST REGISTRATION -->
  <modal-comp [compOptions]="{'id': (isCordova) ? 'customModalPostRegistrationCordova' : 'customModalPostRegistration', closable: false}" *ngIf="displayModalPostRegistration" (canClose)="hideModalPostRegistration()">
    <ng-container *ngIf="!displayModalObjectifCode && !displayModalHasAutoEcole && !displayModalHasNotAutoEcole">
      <img class="illu-first-screen" src="assets/2022/illustrations/heureux-kass.svg" alt="EnVoitureSimone">
      <h4>Bienvenue</h4>
      <p>Juste une question,<br>es-tu déjà inscrit en auto-école&nbsp;?</p>
      <form class="form-post-registration padding-3">
        <input type="radio" id="ae-oui" name="auto-ecole" value="oui" [(ngModel)]="insAutoEcole">
        <label class="evs-card-ui light text-center" for="ae-oui">Oui</label>
        <input type="radio" id="ae-non" name="auto-ecole" value="non" [(ngModel)]="insAutoEcole">
        <label class="evs-card-ui light text-center" for="ae-non">Non</label> 
      </form>
      <button class="btn full-width margin-3 margin-top-16" [disabled]="!insAutoEcole" (click)="sendInsAutoEcoleValue()">Valider</button>
    </ng-container>
    <ng-container *ngIf="displayModalObjectifCode && !displayModalHasAutoEcole && !displayModalHasNotAutoEcole">
      <div class="">
        <img class="illu-second-screen" src="assets/png/poignee_de_main.png" alt="EnVoitureSimone">
        <h4>Objectif Code</h4>
        <p>Tu penses réviser ton code&nbsp;?</p>
        <form class="form-post-registration padding-3">
          <div>
            <input type="radio" id="oc-very_strong" name="objectif-code" value="very_strong" [(ngModel)]="objectifCode">
            <label class="evs-card-ui light content-center" for="oc-very_strong"><img src="assets/png/formule_1.png" width="24">&nbsp;1h/jour</label>
          </div>
          <div>
            <input type="radio" id="oc-strong" name="objectif-code" value="strong" [(ngModel)]="objectifCode">
          <label class="evs-card-ui light content-center" for="oc-strong"><img src="assets/png/vespa.png" width="24">&nbsp;20 min/jour</label>
          </div>
          <div>
            <input type="radio" id="oc-weak" name="objectif-code" value="weak" [(ngModel)]="objectifCode">
          <label class="evs-card-ui light content-center" for="oc-weak"><img src="assets/png/trotinette.png" width="24">&nbsp;5 min/jour</label>
          </div>
          <div>
            <input type="radio" id="oc-very_weak" name="objectif-code" value="very_weak" [(ngModel)]="objectifCode">
          <label class="evs-card-ui light content-center" for="oc-very_weak"><img src="assets/png/marche.png" width="24">Quand j’ai le temps</label>
          </div>
        </form>
        <button class="btn full-width margin-3 margin-top-16" [disabled]="!objectifCode" (click)="sendObjectifCode()">Valider</button>
      </div>
    </ng-container>
    <ng-container *ngIf="displayModalHasAutoEcole">
      <div class="">
        <img class="illu-third-screen" src="assets/2022/illustrations/heureux-paul.svg" alt="EnVoitureSimone">
        <h4>C’est noté&nbsp;!</h4>
        <p>Bonne chance pour ton permis&nbsp;!</p>
        <p>Tu peux toujours<br><b>compléter ta formation</b><br>chez En Voiture Simone :</p>
        <p class="bullet-feu"><img src="assets/svg/feu_tricolore.svg" alt="EnVoitureSimone"> <b>Formation au Code</b> gratuite</p>
        <p class="bullet-car"><img src="assets/svg/red_car.svg" alt="EnVoitureSimone"> <b>Leçons de conduite</b>&nbsp;dès {{minHourPrice}}</p>
        <button class="btn full-width margin-top-16" (click)="hideModalPostRegistration('serie-discovery')">Réviser le code</button>
      </div>
    </ng-container>
    
    <ng-container *ngIf="displayModalHasNotAutoEcole">
      <div class="">
        <img class="illu-fourth-screen" src="assets/2022/illustrations/heureux-kass.svg" alt="EnVoitureSimone">
        <h4>Faites le bon choix&nbsp;!</h4>
        <p>Pour seulement {{packPermisPrice}}, le <b>Pack Permis</b> sera ton meilleur allié. Il comprend :</p>
        <p class="bullet-book"><img src="assets/svg/open_book.svg" alt="EnVoitureSimone"> Un livret de code papier</p>
        <p class="bullet-graduation"><img src="assets/svg/graduation_mall.svg" alt="EnVoitureSimone"> Un accès illimité à nos experts du code</p>
        <p class="bullet-car"><img src="assets/svg/red_car.svg" alt="EnVoitureSimone"> {{packPermisHours}} de conduite sur boîte manuelle</p>
        <button class="btn light full-width margin-top-16" (click)="redirectToCode('serie-discovery')">Commencer le code</button>
        <button class="btn full-width margin-top-8 button-smiley" (click)="redirectToPermis()">Ça m’intéresse <img src="assets/svg/open_hands.svg" alt="EnVoitureSimone"></button>
      </div>
    </ng-container>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalDossierExam1'}" *ngIf="displayModalDossierExam1" (canClose)="hideModalDossierExam1()">
    <h4>Plus qu’une étape&nbsp;!</h4>
    <p>Pour réserver ton examen, tu dois mettre en ligne ton attestation d’inscription. Une fois validée par notre équipe, tu pourras choisir ta date d’examen dans le centre La Poste de ton choix.</p>
    <button class="btn center" (click)="openLink('dossier')">Mettre en ligne mon attestation</button>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalDossierExam2', dynamicHeight: true}" *ngIf="displayModalDossierExam2" (canClose)="hideModalDossierExam2()">
    <h4>Ton document est en cours de validation</h4>
    <p>Ton attestation d’inscription est en cours de vérification par notre équipe. Une fois validée, tu recevras un mail de confirmation et pourras choisir ta date d’examen dans le centre La Poste de ton choix.</p>
    <button class="btn center" (click)="hideModalDossierExam2()">J’ai compris</button>
  </modal-comp>
  
  <modal-comp class="text-center" [compOptions]="{'id': 'customModalNoErrors', closable: false}" *ngIf="displayModalNoErrors" (canClose)="hideModalNoErrors()" #modalNoErrors>
    <h4>Mes erreurs</h4>
    <p>Tu n'as pas fait d'erreur... Bravo&nbsp;!<br>Essaye d'autres modes d'entraînement et reviens plus tard.</p>
    <button class="btn center" (click)="callHideModalNoErrors()">J’ai compris</button>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalCPFSubscription', closable: false}" *ngIf="displayModalCPFSubscription" (canClose)="hideModalCPFSubscription()">
    <img src="assets/svg/asset-avis-alt.svg" alt="EnvoitureSimone">
    <h4 class="text-center">Très bon choix !</h4>
    <p class="text-center">Ton inscription via ton <span class="bold">Compte de Formation</span> est bien enregistrée.</p>
    <div class="icon-text-wrapper">
      <p>📚</p>
      <p>Tu peux dès maintenant réviser ton code de la route en illimité !</p>
    </div>
    <button class="btn full-width" (click)="hideModalCPFSubscription()">Découvrir ma formation</button>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalDailyStreak', closable: false}" *ngIf="displayModalDailyStreak" (canClose)="hideModalDailyStreak()" #modalDailyStreak>
    <img class="close-btn small-clickable" [src]="'assets/2022/icons/close-on.svg'" (click)="callHideModalDailyStreak()">
    <div class="calendar-headers-wrapper">
      <img class="flamme" src="assets/2022/pictos/flamme.svg" alt="EnvoitureSimone">
      <h4 class="daily-streak-title text-center" *ngIf="isDesktop">Mes jours d'entraînement</h4>
      <h5 class="daily-streak-title text-center" *ngIf="!isDesktop">Mes jours d'entraînement</h5>
      <p class="daily-streak-desc text-center">Réponds à une question de code par jour pour maintenir ta série</p>
      <div class="streak-record-wrapper">
        <div class="streak-record">
          <img [src]="'assets/2022/icons/flamme.svg'">
          <div>
            <p>Série en cours</p>
            <p>{{ currentDailyStreakText }}</p>
          </div>
        </div>
        <div class="streak-record">
          <img [src]="'assets/2022/icons/coupe.svg'">
          <div>
            <p>Meilleure série</p>
            <p>{{ maxDailyStreakText }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="calendar-wrapper">
      <calendar-daily-streak [compOptions]="{'dailyStreakDates': gamificationService.dailyStreaks.dates}"></calendar-daily-streak>
    </div>
  </modal-comp>

  <div *ngIf="showEmbedElt" class="embed-video-container">
    <div class="close-btn clickable" (click)="hideModalEmbed()">
      <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
    </div>
    <div class="embed-video">
      <iframe loading="lazy" [src]="embedSrc" allow="autoplay" allowfullscreen></iframe>
    </div>
  </div>

</ion-content>
  
<modal-comp [compOptions]="{'id': 'customModalNEPHInfos', closable: false}" *ngIf="displayModalNEPHInfos" (canClose)="hideModalNEPHInfos()" #modalNEPHInfos>
  <div class="close-btn clickable" (click)="callHideModalNEPHInfos()">
    <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
  </div>
  <div class="content-wrapper">
    <h5>Inscription sur l'ANTS</h5>
    <div class="text-wrapper">
      <p>Pourquoi s'inscrire sur l'ANTS<br>On t'explique 👇</p>
      <p>
        Si tu n'as jamais été inscrit en auto-école, tu dois t'inscrire sur l'ANTS (Agence Nationale des Titres Sécurisés) pour obtenir ton attestation d'inscription au permis de conduire. Sur cette attestation, tu trouveras ton numéro NEPH (suite de 12 chiffres).
        <br>Ce numéro est obligatoire pour passer le code de la route et l'examen du permis de conduire.
      </p>
      <p class="bold">⚠️ Les délais moyens d'obtention du NEPH sont de 2 à 4 semaines !</p>
    </div>
  </div>
  <div class="button-wrapper">
    <button class="btn full-width" (click)="neverBeenRegisteredAE()">Je n'ai jamais été inscrit en auto-école</button>
    <button class="btn light full-width" (click)="alreadyRegisteredAE()">J'ai déjà été inscrit en auto-école</button>
  </div>
</modal-comp>
  
<modal-comp [compOptions]="{'id': 'customModalANTSInfos', closable: false}" *ngIf="displayModalANTSInfos" (canClose)="hideModalANTSInfos()" #modalANTSInfos>
  <div class="close-btn clickable" (click)="callHideModalANTSInfos()">
    <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
  </div>
  <div class="back-btn clickable" (click)="goBackToModalNEPHInfos()">
    <img src="assets/2022/icons/arrow-left-2-off.svg" alt="EnVoitureSimone" height="24">
  </div>
  <div class="content-wrapper">
    <h5>Inscription sur l'ANTS</h5>
    <div class="text-wrapper">
      <p class="bold">Pour obtenir ton NEPH ? C'est simple !</p>
      <p>Inscris-toi directement sur <span class="article-link clickable bold" (click)="openLinkGouvNEPH()">le site de l'ANTS</span></p>
      <p>Et si tu as besoin d'aide, jette un oeil à notre vidéo ou à <span class="article-link clickable bold" (click)="openLink('howNEPH')">notre article sur le sujet</span> !</p>
      <p class="bold">⚠️ Les délais moyens d'obtention du NEPH sont de 2 à 4 semaines !</p>
    </div>
    <div class="embed-video">
      <iframe loading="lazy" [src]="embedSrcANTS" allowfullscreen></iframe>
    </div>
  </div>
  <div class="button-wrapper">
    <button class="btn full-width" (click)="openLinkGouvNEPH()">Je m'inscris sur l'ANTS</button>
  </div>
</modal-comp>

<ion-footer *ngIf="!showIOSATTScreen && !showEmbedElt && !displayModalPostRegistration && !displayModalCPFSubscription && !displayModalDailyStreak">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
